import { render, staticRenderFns } from "./OrdersInvalid.vue?vue&type=template&id=1c0ed630"
import script from "./OrdersInvalid.vue?vue&type=script&lang=js"
export * from "./OrdersInvalid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports